import { BlogPostCard } from "./blog-post-card";
import { cn } from "@/lib/utils";
import type { BlogPostSummary } from "@/types/blog";

interface BlogGridProps {
  posts: BlogPostSummary[];
  className?: string;
}

export function BlogGrid({ posts, className }: BlogGridProps) {
  if (posts.length === 0) {
    return (
      <div className={cn("text-center py-16", className)}>
        <h3 className="text-2xl font-bold text-white mb-4">No posts found</h3>
        <p className="text-gray-400">
          Try adjusting your search or filter criteria.
        </p>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "grid grid-cols-1 font-outfit md:grid-cols-2 lg:grid-cols-3 gap-8",
        className
      )}
    >
      {posts.map((post) => (
        <BlogPostCard key={post.id} post={post} />
      ))}
    </div>
  );
}
